const BLANK_TARGET = '_blank';
const JOIN_URLS = ['/join/', '/انضم/'];
const LINK_TARGETS = {
  JOIN: 'join',
};

export { BLANK_TARGET, JOIN_URLS, LINK_TARGETS };
